
import apiRequestType from "../../apiRequestType";
import { apiTypes } from "../../../utils/apiTypes";
import { apiConstants } from "../../../utils/apiConstants";

const updateDomainName = (data) => {
    return apiRequestType(apiTypes.PUT, apiConstants.ADMIN.ORGANIZATION_SETTINGS.PUT_DOMAIN_NAME, data)
}
export default updateDomainName